import { PartialType } from '../../../utils';
import { CreatePreallocationDto } from './create-preallocation.dto';
export class UpdatePreallocationDto extends PartialType(CreatePreallocationDto) {
}
